export default {
  MEMOS_COUNT_LOADING: '@MEMOS_COUNT_LOADING',
  MEMOS_COUNT_SUCCESS: '@MEMOS_COUNT_SUCCESS',
  MEMOS_COUNT_ERROR: '@MEMOS_COUNT_ERROR',

  MEMOS_ITEMS_LOADING: '@MEMOS_ITEMS_LOADING',
  MEMOS_ITEMS_SUCCESS: '@MEMOS_ITEMS_SUCCESS',
  MEMOS_ITEMS_ERROR: '@MEMOS_ITEMS_ERROR',
  MEMOS_ITEMS_CLEAR: '@MEMOS_ITEMS_CLEAR',

  MEMOS_SEARCH_LOADING: '@MEMOS_SEARCH_LOADING',
  MEMOS_SEARCH_SUCCESS: '@MEMOS_SEARCH_SUCCESS',
  MEMOS_SEARCH_ERROR: '@MEMOS_SEARCH_ERROR',
  MEMOS_SEARCH_CLEAR: '@MEMOS_SEARCH_CLEAR',

  MEMOS_ITEM_DETAILS_LOADING: '@MEMOS_ITEM_DETAILS_LOADING',
  MEMOS_ITEM_DETAILS_SUCCESS: '@MEMOS_ITEM_DETAILS_SUCCESS',
  MEMOS_ITEM_DETAILS_ERROR: '@MEMOS_ITEM_DETAILS_ERROR',
  MEMOS_ITEM_DETAILS_CLEAR: '@MEMOS_ITEM_DETAILS_CLEAR',

  MEMOS_STORE_COUNT_LOADING: '@STORE_MEMOS_COUNT_LOADING',
  MEMOS_STORE_COUNT_ERROR: '@STORE_MEMOS_COUNT_ERROR',
  MEMOS_STORE_COUNT_SUCCESS: '@MEMOS_STORE_COUNT_SUCCESS',

  MEMOS_STORE_ITEMS_ERROR: '@MEMOS_STORE_ITEMS_ERROR',
  MEMOS_STORE_ITEMS_SUCCESS: '@MEMOS_STORE_ITEMS_SUCCESS',

  MEMOS_STORE_CLEAR: '@MEMOS_STORE_CLEAR',
  MEMOS_STORE_FILTERS: '@MEMOS_STORE_FILTERS',
  MEMOS_STORE_RESET_FILTERS: '@MEMOS_STORE_RESET_FILTERS',

  SELECT_ASSOCIATE_MEMOS: '@SELECT_ASSOCIATE_MEMOS',
};
